import { PrimarySecondaryPage } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { useIntl } from "react-intl";

import { BankStatementUpload, BankStatementUploadSecondaryContent } from "../../../components";

export const AirBankStatementsPage = ({
  customerDomain,
  air,
  onBack,
}: {
  customerDomain: string;
  air: FundingApplicationSchemas.AIRSchema;
  onBack: () => void;
}) => {
  const intl = useIntl();

  return (
    air.air_data && (
      <PrimarySecondaryPage
        title={intl.formatMessage({
          id: "funding-application: air bank statement required title",
          defaultMessage: "Upload your bank statements",
        })}
        primaryContent={
          <BankStatementUpload
            airPublicId={air.air_data.public_identifier}
            bankData={air.air_data.data as FundingApplicationSchemas.BankStatementsForAccountAIRSchema}
            customerDomain={customerDomain}
            onBack={onBack}
          />
        }
        secondaryContent={<BankStatementUploadSecondaryContent />}
      />
    )
  );
};
